<template>
  <div class="container-fluid mt--6 tbl-flt-sch">
      <div class="row xsOnly">
        <div class="col-xl-12">
          <div class="card scrollbar vh-75" id="scroll">
            <div class="table-responsive">
                <h4 class="d-inline-block py-4">
                  <div class="">
                    Live Offers : <span class="badge">{{liveOffersCount ? liveOffersCount : 0}}</span> 
                    Total Par   <span class="hint mt-2" data-toggle="tooltip" data-placement="right"  title="The total quantity offered from DRL's inventories.">
                      <i class="fa fa-info-circle" style="color: #ffa300"></i> </span> : <span class="badge">{{totalParCount ? totalParCount : 0}}</span>

                    <span 
                      @click="getOfferStatus()" 
                      style="margin:5px" 
                      class="fas fa-sync-alt  cursor-pointer" 
                      v-bind:class="{ 'fa-spin': countLoading }"
                      data-toggle="tooltip" 
                      data-placement="left" 
                      title="Refresh count"
                      aria-hidden="true"></span> 
                  </div>
                </h4>
                <!-- Table Search -->
                  <div class="input-group col-md-2 tbl-sch rounded" style="top:23px">
                      <input v-on:keyup.enter="searchOffer" @keypress="isAlphanumeric($event)" type="text" v-model.trim="searchValue" class="form-control rounded" placeholder="Search" />
                      <span v-if="searchValue" @click="clearSearch()" class="cursor-pointer input-group-text border-0"><i class="fas fa-times"></i></span>
                      <span @click="searchOffer()" class="cursor-pointer input-group-search border-0"><i class="fas fa-search"></i></span>
                  </div>

                <!-- Table Filter -->
                  <div class="col-md-3 tbl-filter">
                    <label>Filter By Offer Status</label>
                    <multiselect 
                    v-model="offerStatus" 
                    placeholder="Select Offer Status" 
                    label="name" 
                    @input="removeDuplicates" 
                    track-by="code" 
                    :options="options" 
                    :multiple="true" 
                    :limit="3"  ></multiselect>
                    <button @click="searchOffer()" type="button" class="flt-btn btn btn-success"><i class="fas fa-filter"></i></button>
                  </div>
                  <div class="col-md-3 tbl-filter">
                    <label>Filter By Holding Status</label>
                    <multiselect 
                      v-model="holdingStatus" 
                      placeholder="Select Status" 
                      label="name" 
                      track-by="code" 
                      :options="holdingOptions" 
                      :multiple="true" 
                      :limit="2" ></multiselect>
                    <button @click="searchOffer()" type="button" class="flt-btn btn btn-success"><i class="fas fa-filter"></i></button>
                  </div>
                  <table class="table align-items-center table-flush table-hover bidtbl imstbl">
                      <thead class="thead-light psticky">
                      <tr >
                          <th 
                          scope="col" 
                          class="sort"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                          @click="sort('cusip')">CUSIP/DESC</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                          @click="sort('quantity')">QTY</th>
                          <th
                            scope="col"
                            class="sort text-center"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'executedQuantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'executedQuantity'  ? 'sort-desc' : '']"  
                            @click="sort('executedQuantity')">Fill/Rem
                            </th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'price'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'price'  ? 'sort-desc' : '']"  
                          @click="sort('price')">PRICE</th>
                          <!-- <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offerValidity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offerValidity'  ? 'sort-desc' : '']"  
                          @click="sort('offerValidity')">OFFER <br> VALIDITY</th> -->
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'status'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'status'  ? 'sort-desc' : '']"  
                          @click="sort('status')">OFFER <br>  STATUS</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offerType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offerType'  ? 'sort-desc' : '']"  
                          @click="sort('offerType')">OFFER <br>  TYPE</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'coupon'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'coupon'  ? 'sort-desc' : '']"  
                          @click="sort('coupon')">COUPON</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cost'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cost'  ? 'sort-desc' : '']"  
                          @click="sort('cost')">COST</th>
                          <th
                          scope="col"
                          class="sort text-left">TMC<br>Status/Price
                          </th>
                          <th
                          scope="col"
                          class="sort text-left">TWR<br>Status/Price
                          </th>
                          <th
                          scope="col"
                          class="sort text-left">KBP<br>Status/Price
                          </th>
                          <th
                          scope="col"
                          class="sort text-left">MKTX<br>Status/Price
                          </th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yield'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yield'  ? 'sort-desc' : '']"  
                          @click="sort('yield')">YIELD</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yieldSpread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yieldSpread'  ? 'sort-desc' : '']"  
                          @click="sort('yieldSpread')">SPREAD</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'balance'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'balance'  ? 'sort-desc' : '']"  
                          @click="sort('balance')">BAL/MIN/INC</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'firstName'  ? 'sort-desc' : '']"  
                          @click="sort('traderName')">TRADER</th>
                          <!-- <th
                            scope="col"
                            class="sort text-left">SOURCE
                          </th> -->
                          <th scope="col" class="text-center">Action</th>
                      </tr>
                      </thead>
                      <tbody class="list">
                      <tr v-if="totalRows == 0 && !loading">
                          <td><p class="nodata">No data available</p>
                          </td>
                      </tr>
                      <tr v-for="offer in offerings" :key="offer.id" @click="getOfferDetails(offer)" v-bind:class="{'active-row': offer.isActive}">
                          <td>
                              <span class="cusips"  v-bind:class="'cusip-'+offer.cusipColour">{{offer.cusipVal}}</span>
                              <span class="desc" v-bind:class="'cusipDes-'+offer.cusipDescColour">{{offer.cusipDescription}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.quantity}}</span><br>
                          </td>
                           <td class="text-center">
                              <span class="mr-3 d-inline-block">Fill<br><span class="text-danger d-block">{{offer.executedQuantity || 0}}</span></span>
                              <span class="d-inline-block">REM<br><span class="text-success d-block">{{(offer.quantity - offer.executedQuantity) || 0}}</span></span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.price | currency}}</span><br>
                          </td>
                          <!-- <td class="text-center">
                              <span>{{offer.offerValidity}}</span><br>
                          </td> -->
                          <td class="text-center">
                              <span>{{offer.status}}</span><br>
                          </td>
                          <td class="text-center">
                              <span>{{offer.offerType}}</span><br>
                          </td>
                          
                          <td class="text-center">
                              <span>{{offer.coupon |  percent(3)}}</span><br>
                          </td>
                          <td class="text-center">
                              <span>{{offer.cost | currency}}</span><br>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.tmcStatus).message" v-bind:class="getEcnStatus(offer.tmcStatus).className">{{offer.tmcStatus}}</span>
                              <span class="text-primary">{{offer.tmcprice | currency}}</span>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.twdStatus).message" v-bind:class="getEcnStatus(offer.twdStatus).className">{{offer.twdStatus}}</span>
                              <span class="text-primary">{{offer.twdprice | currency}}</span>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.ibpStatus).message"  v-bind:class="getEcnStatus(offer.ibpStatus).className">{{offer.ibpStatus}}</span>
                              <span class="text-primary">{{offer.ibpprice | currency}}</span>
                          </td>
                          <td class="text-left">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.mktxStatus).message"  v-bind:class="getEcnStatus(offer.mktxStatus).className">{{offer.mktxStatus}}</span>
                              <span class="text-primary">{{offer.mktxPrice | currency}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.yield}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{(offer.price - offer.cost).toFixed(3)}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.balance}} - {{offer.minimum}} - {{offer.incrementVal}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.firstName}} {{offer.lastName}}</span>
                          </td>
                          <!-- <td class="text-center">
                              <span>{{offer.offerSource.toString()}}</span>
                          </td> -->
                          <td class="text-center">
                            <a v-if="isAdmin || isEditor || isTrader"  @click="editOffer(offer)" class="btn ibtn grn"><i class="fas fa-pencil-alt"></i></a>
                            <button @click="openCustomerDetailsModal(offer)" class="btn ibtn btn-outline-primary" title="Customers"><i class="far fa-user"></i></button>
                            <div  class="dropdown">
                                <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                </button>
                                <div  class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    <!-- <button @click="movetomsrb(offer)"  class="dropdown-item" type="button">Move to MSRB</button> -->
                                    <!-- <button v-if="offer.status == 'ECN_SENT'"  class="dropdown-item del" type="button">Cancel</button> -->
                                    <button v-if="isAdmin || isEditor" @click="deleteOffer(offer)"  class="dropdown-item del" type="button">Delete</button>
                                    <button v-if="(isAdmin || isEditor) && settings.isSendToEcn && offer.status == 'ECN_SENT'" @click="suspendOffer(offer)"  class="dropdown-item del" type="button">Suspend</button>
                                    <button v-if="(isAdmin || isEditor) && settings.isSendToEcn && offer.status == 'NEW' || offer.status == 'ECN_SENT' || offer.status == 'SUSPENDED'"  @click="reuploadOffer(offer)"  class="dropdown-item del" type="button">Reupload</button>
                                    <button @click="toggleChangeTraderModal();selectedOffer = offer"  class="dropdown-item" type="button">Change Trader</button>


                                </div>
                            </div>
                          </td>
                          </tr>
                      </tbody>
                      <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                  </table>
                  <!-- Pagination-->
                  <b-pagination
                      class="mt-4"
                      :total-rows="totalRows"
                      v-model="currentPage"
                      :per-page="perPage"
                      @input="getOfferList()"
                  ></b-pagination>
                  <div class="total-records">
                      <span>Total Records : {{totalRows}}</span>
                  </div>
            </div>
          </div>
        </div>
      </div>
      <add-offer
            v-if="editOfferModalOpen"
            v-bind:offerCusip="offerCusip"  
            v-bind:selectedOffer="selectedOffer"  
            v-bind:mode="'EDIT'"  
            @close="editOfferModalOpen = false">
      </add-offer>
  <customer-details v-if="customerDetailModalOpen" v-bind:offerData="selectedOffer"   @close="customerDetailModalOpen = false" />   
  <ChangeTrader v-if="changeTraderModalOpen" v-bind:offerData="selectedOffer"   @close="toggleChangeTraderModal()" />
  </div>    

</template>
<script>
import config from "@/config";
import authService from "@/authService";
import stateConstants from "@/stateConstants";
import addOffer from "./ImsAddOfferModal"
import customerDetails from "./ImsOfferingCutomerDetails"
import ecnStatus from "@/ecnStatus";
import ChangeTrader from "./ImsChangeTraderModal"
export default {
  name: "imsAllOfferListComponent",
  components : {
    addOffer,
    customerDetails,
    ChangeTrader
  },
  data() {
    return {
        accessToken: null,
        config: config,
        loading : false,
        currentPage: 1,
        perPage: 20,
        searchValue : "",
        totalRows : 0,
        selectedCusip : "",
        sortColumn: "latestDate",
        sortOrder: "DESC",
        stateConstants: stateConstants,
        offerings:[],
        editOfferModalOpen : false,
        offerCusip : null,
        customerDetailModalOpen : false,
        selectedOffer : {},
        offerStatus: [],
        options: [
          { name: 'New', code: 'NEW' },
          { name: 'Hold', code: 'HOLD' },
          { name: 'Suspended', code: 'SUSPENDED' },
          { name: 'Waiting', code: 'WAITING_EXCECUTION' },
          { name: 'Ecn Sent', code: 'ECN_SENT' },
          { name: 'Ecn to be sent', code: 'TO_BE_SEND_ECN' },
          { name: 'Hold on holding upload', code: 'HOLD_ON_HOLDINGS_UPLOAD' },
          { name: 'Hold on mismatch', code: 'HOLD_ON_MISMATCH' },

        ],
        holdingStatus: [],
        holdingOptions: [
          { name: 'Bought Date Different', code: 'BOUGHT_DATE_DIFFERENT' },
          { name: 'Qty increased', code: 'HOLDING_QTY_INCREASED' },
          { name: 'Qty Decreased', code: 'HOLDING_QTY_DECREASED' }
        ],
        ecnStatus : ecnStatus,
        isAdmin: false,
        isEditor : false,
        isTrader : false,
        liveOffersCount : 0,
        settings : {isSendToEcn : true},
        countLoading : false,
        changeTraderModalOpen : false,
        totalParCount : 0


    };
  },
  methods: {
    toggleChangeTraderModal(){
      this.changeTraderModalOpen = !this.changeTraderModalOpen;
      if(!this.changeTraderModalOpen){
        this.getOfferList();
      }
    },
    removeDuplicates(data){
      this.offerStatus = data.filter((role, index, self) =>
        index === self.findIndex((t) => (
          t.code === role.code && t.name === role.name
        ))
      )
    },
    getEcnStatus(ecnStatus){
      //console.log(this.ecnStatus)
      var ecnData = this.ecnStatus.find(x => x.status === ecnStatus);
      if(ecnData){
        var className = ecnData.type == 'error'  ? 'border-warning text-error' : 'border-success text-success';
        return  { className : className ,status : ecnStatus,message : ecnData.message }
      }else{
        return  { className : 'border-success text-success' ,status : ecnStatus, message : "" }
      }
      
    },
    searchOffer(){
     // console.log("d",this.offerStatus.map((status) => {return status.code}).toString())
      this.getOfferList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getOfferList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getOfferList();
    },
    getStateName(id){
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    },
    getOfferDetails(offerSelected){
      this.offerings.forEach(function(offer) {
        offer.isActive = false;
      });
      offerSelected.isActive = true;
    },
    getOfferList() {
      this.loading = true;
      let ecnStatus = "";
      if(this.offerStatus.length == 0){
        ecnStatus = this.options.map((status) => {return status.code}).toString();
      }else{
        ecnStatus = this.offerStatus.map((status) => {return status.code}).toString();
      }
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/offer/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status="+
            ecnStatus +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&cusips="+
            "&accountMappingIds="+
            "&holdingUploadStatus="+
             this.holdingStatus.map((status) => {return status.code}).toString()+
             "&createSource=self,import,autobidder_ibp,autobidder_tmc,autobidder_twd",
            auth

        )
        .then(result => {
          //console.log(result);
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(function(cusip) {
           cusip.isActive = false;
          });
           this.offerings = result.data.content;
           this.loading = false;
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    editOffer(offer){
      this.selectedOffer = {...offer};
      let cusip = {};
          cusip.cusip = offer.cusipVal;
          cusip.maturityDate = offer.maturityDate;
          cusip.callDate = offer.callDate;
          cusip.coupon = offer.coupon;
          cusip.stateId = offer.stateId;
          cusip.id = offer.cusipId;
          cusip.offeringTypeId = offer.offeringTypeId;
      this.offerCusip = cusip;
      this.editOfferModalOpen = true;
    },
    // searchCusip(cusip){
    //     this.loading = true;
    //     const auth = {
    //         headers: { 'org-token' : authService.getOrgToken() }
    //     };
    //     this.$http
    //     .get(
    //       config.baseUrlBidSide +
    //         "/cusip/list?page=1&status=ACTIVE,BLOCKED&sortColumn=cusip&sortOrder=ASC&type=OFFER"+
    //         "&cusip=" +
    //         cusip,
    //         auth
    //     )
    //     .then(result => {
    //       if(result.data.content.length > 0){
    //         this.offerCusip = result.data.content[0];
    //         this.editOfferModalOpen = true;
    //       }
    //       this.loading = false;
    //     })

    //  },
     openCustomerDetailsModal(offer){
       this.selectedOffer = offer;
       this.customerDetailModalOpen = true;   
     },
     movetomsrb(offer){
      var message = "Are you sure you want to move this offer to MSRB?";
      this.$confirm(message,"Move to MSRB","",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
                  "id":offer.id,
                  "status":"MSRB",
                  "updateByCognitoSub" : authService.getUser().cognitoSub
              }
          this.$http
          .put(config.baseUrlBidSide + "/offer/status",data,auth)
          .then(() => {
            this.loading = false;              
            this.getOfferList();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });
     },
    suspendOffer(offer){
      var message = "Are you sure you want to suspend this offer?";
      this.$confirm(message,"Suspend offer","",{confirmButtonText:"Suspend",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
                  "offerId":offer.id,
                  "cognitoSub": authService.getUser().cognitoSub
              }
          this.$http
          .post(config.baseUrlBidSide + "/offer/suspend-offer",data,auth)
          .then(() => {
            this.loading = false;              
            this.getOfferList();
          })
          .catch(() => {
              this.loading = false;              
          });
      });
     },
     reuploadOffer(offer){
      var message = "Are you sure you want to reupload this offer?";
      this.$confirm(message,"Reupload offer","",{confirmButtonText:"Reupload",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
                  "offerId":offer.id,
                  "cognitoSub": authService.getUser().cognitoSub
              }
          this.$http
          .post(config.baseUrlBidSide + "/offer/reupload-offer",data,auth)
          .then((result) => {
            this.loading = false;
            if(result.data.show){
              this.sentToEcnModalOpen = true;
              this.offerSenttoEcn = result.data
            }else{
              this.$alert("Offer reupload successfully","","success");
            }              
            this.getOfferList();
          })
          .catch(() => {
              this.loading = false;              
          });
      });
     },
     deleteOffer(offer){
      var message = "Are you sure you want to delete this offer?";
      this.$confirm(message,"Delete offer","",{confirmButtonText:"Delete",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
                  "id":offer.id,
                  "status":"DELETED",
                  "updateByCognitoSub" : authService.getUser().cognitoSub
              }
          this.$http
          .put(config.baseUrlBidSide + "/offer/status",data,auth)
          .then(() => {
            this.loading = false;              
            this.getOfferList();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });
     },
     getOfferStatus(){
      this.countLoading = true;
      let url = "/offer/stats";
      const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
      .get(
        config.baseUrlBidSide + url,
          auth
      )
      .then(result => {
        this.liveOffersCount = result.data.live;
        this.totalParCount = result.data.bidCount;
        this.countLoading = false;
      })

    },
    getSettings(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/organization/bid-settings?type=OFFER",
            auth
        )
        .then(result => {
          this.settings = result.data;

        })        
    },
  },
  mounted() {
    this.getOfferList();
    this.getOfferStatus();
    this.getSettings();
    this.$root.$on("offercreatedorupdated", () => {
      this.getOfferList();
    });
    this.$root.$on("dailyuploaded", () => {
      this.getSettings();
    });
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          //console.log(role)
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          //roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
        }
        //console.log("isa",this.isAdmin);
      });
  },
  beforeDestroy() {
    this.$root.$off("offercreatedorupdated");
    this.$root.$off("dailyuploaded");
  }
};
</script>
<style scoped>
.badge{
  min-width: 50px
}
.tbl-flt-sch .tbl-filter{
  right: 0px;
}
.tbl-sch{
  right: 0px;
}
</style>